import { yupResolver } from '@hookform/resolvers/yup';
import {
  Box,
  Grid,
  Button,
  FormGroup,
  FormLabel,
} from '@mui/material';

import { CreateFolderForm, ExpertContent } from 'pages/media-library/interface';
import React from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { FileType } from 'utils/file-uploader';
import { mediaLibraryAction } from 'pages/media-library/slice';
import { ErrorMessage, PrimaryTextField } from '../../../../components';
import RenameMediaValidationSchema from '../upload-new-media/validation/rename-media';
import { createFolderValidationSchema } from '../upload-new-media/validation/add-media';

interface RenameMediaFormProps {

  // eslint-disable-next-line react/require-default-props
  media?: ExpertContent;
}
const RenameMediaForm = ({ media }:RenameMediaFormProps) => {
  const dispatch = useDispatch();

  const {
    register, handleSubmit, formState: { errors },
  } = useForm<CreateFolderForm>({
    resolver: yupResolver(
      media?.fileCategory === FileType.FOLDER
        ? createFolderValidationSchema : RenameMediaValidationSchema,
    ),
    shouldFocusError: true,
    defaultValues: {
      name: media?.title,
    },
  });

  const onSubmit: SubmitHandler<CreateFolderForm> = React.useCallback(async (data) => {
    dispatch(mediaLibraryAction.updateMedia({
      id: media?._id as string,
      title: data.name,
      path: media?.path,
      expertId: media?.expertId,
    }));
  }, [dispatch, media?._id]);

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)}>
      <Grid container rowSpacing={6}>
        <Grid item xs={12}>
          <FormGroup>
            <FormLabel sx={{ mb: 2 }}>
              {`${media?.fileCategory === FileType.FOLDER ? 'Folder' : 'File'} name`}
            </FormLabel>
            <PrimaryTextField placeholder={`Enter ${media?.fileCategory === FileType.FOLDER ? 'folder' : 'file'} name`} {...register('name')} />

            {errors.name && (<div className="mt-2"><ErrorMessage>{errors?.name?.message}</ErrorMessage></div>)}

          </FormGroup>
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" fullWidth>
            Update
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RenameMediaForm;
